module.exports = __webpack_public_path__ + "static/media/lamp-desk.ffddc118.svg";